module.exports = __webpack_public_path__ + "img/finishExmRoom.e6df2626.png";